module.exports = __webpack_public_path__ + "static/media/bye-light.1fe1530f.svg";